"use client";

import { Bars3Icon } from "@heroicons/react/24/outline";

import { useSidebar } from "@/lib/zustand/useSidebar";
import { cn } from "@/utils/cn";

export function SidebarMenuButton({ className }: { className?: string }) {
  const setOpen = useSidebar((state) => state.setOpen);

  return (
    <button
      type="button"
      aria-label="Open sidebar"
      className={cn(
        "-m-2.5 rounded-md p-2.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
        className
      )}
      onClick={setOpen}
    >
      <Bars3Icon className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
